import React from 'react';
import ReactDOM from 'react-dom';

interface ModalProps {
    children: React.ReactNode;
}

export const Modal: React.FunctionComponent<ModalProps> = props => ReactDOM.createPortal(props.children, document.getElementById('modal-root') as Element);